import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Typography from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Typography';
import { withStyles } from 'Components/ComponentLibrary/Styles';
import Paper from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Paper';
import { getBorderRadius, getLightBorder } from 'Components/utils';
import AddButton from './AddButton';
import AvatarPicker from './AvatarPicker';

const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(2),
    marginBottom: theme.spacing(1),
    ...getBorderRadius(theme.radius.md, { all: true }),
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    paddingBottom: theme.spacing(1),
  },
  headerBordered: {
    paddingTop: theme.spacing(1),
    ...getLightBorder(theme, { top: true }),
  },
  title: {
    flexGrow: 1,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  listItem: {
    marginTop: theme.spacing(1),
  },
  avatar: {
    margin: theme.spacing(1, 1, 0, 0),
  },
});

const PrimaryCard = ({
  className,
  classes,
  onAdd,
  header,
  title,
  resource,
  children,
}) => {
  return (
    <Paper
      className={classNames(classes.root, className)}
      variant={'outlined'}
    >
      {header}
      <div className={classNames(classes.header, {
        [classes.headerBordered]: header !== null,
      })}
      >
        <AvatarPicker
          className={classes.avatar}
          resource={resource}
        />
        <Typography
          className={classes.title}
          variant={'h5'}
          weight={'bold'}
          color={'primary'}
          align={'left'}
        >
          {title}
        </Typography>
        {!onAdd
          ? null
          : (<AddButton
            onClick={onAdd}
            test={`primary-card-add-button-${title}`}
          />)
        }
      </div>
      {children}
    </Paper>
  );
};

PrimaryCard.defaultProps = {
  className: '',
  resource: null,
  header: null,
};

PrimaryCard.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  header: PropTypes.node,
  children: PropTypes.node.isRequired,
  onAdd: PropTypes.func.isRequired,
  resource: PropTypes.object,
};

export default withStyles(styles)(PrimaryCard);
